import { Link } from 'react-router-dom';
import { categories } from '@/mocks/posts';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <h4 className="font-heading text-lg font-bold text-foreground-950 mb-4">
              <a href="/" className="hover:text-primary-500 transition-colors cursor-pointer">海角社区</a>
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              连接你我的温暖交流平台。在这里，找到志同道合的朋友，分享生活、情感、兴趣与故事。
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/life" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">生活点滴</Link></li>
              <li><Link to="/category/emotion" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">情感天地</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">热门分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                <span>hello@daipumall.cn</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                <span>中国浙江杭州</span>
              </li>
              <li>
                <Link to="/about#contact" className="inline-flex items-center gap-1 text-primary-500 hover:text-primary-600 transition-colors cursor-pointer font-medium">
                  在线留言 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-background-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-foreground-500">
            &copy; 2026 海角社区 Haijiao Community. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="GitHub">
              <i className="ri-github-line text-lg w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}